import api from './client';

export const getFolders    = (projectId)       => api.get('/project-files/folders', { params: { project: projectId } }).then(r => r.data);
export const createFolder  = (projectId, name) => api.post('/project-files/folders', { project: projectId, name }).then(r => r.data);
export const renameFolder  = (id, name)        => api.put(`/project-files/folders/${id}`, { name }).then(r => r.data);
export const deleteFolder  = (id)              => api.delete(`/project-files/folders/${id}`).then(r => r.data);

export const getFiles      = (projectId, folderId) => api.get('/project-files', { params: { project: projectId, folderId } }).then(r => r.data);
export const uploadFiles   = (projectId, folderId, fileList) => {
  const fd = new FormData();
  fd.append('project', projectId);
  fd.append('folderId', folderId);
  Array.from(fileList).forEach(f => fd.append('files', f));
  return api.post('/project-files/upload', fd).then(r => r.data);
};
export const updateFile    = (id, data)        => api.put(`/project-files/${id}`, data).then(r => r.data);
export const deleteFile    = (id)              => api.delete(`/project-files/${id}`).then(r => r.data);
